import { Button, Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import {
    setManifesto, setEstados, setSelectMunicipios,
    gravarErrors, clearManifesto, loadManifesto,
    setSelectMunicipiosCarregamento, clearNFe, clearCTe,
    clearError, loadMunicipiosDescargaSelect

} from "../../../features/manifestoSlice";
import auxService from "../../../services/AuxService";
import MunicipioCarrega from "./MunicipioCarrega";
import UfPercurso from "./UfPercurso";
import manifestoService from "../../../services/ManifestoService";
import { CamposObrigatorios, JAlertaErrorFormulario, MakeMessageError } from "../../../components/Components";
import { useNavigate, useParams } from "react-router-dom";
import Totalizador from "../totalizador/Totalizador";
import AutorizacaoDownload from "../autorizacao_download/AutorizacaoDownload";
import ProdutoPredominante from "../produto_predominante/ProdutoPredominante";
import { tratarErrors } from "../../../utils/utils";
import InfoManifesto from "../inf_adicionais/InfoManifesto";
import LacresManifesto from "../lacre_manifesto/LacresManifesto";
import InfDocumentos from "../inf_documento/InfDocumentos";
import Rodoviario from "../modal_rodoviario/Rodoviario";
import Seguro from "../inf_seguro/Seguro";
import ModalFormAereo from "../modal_aereo/ModalAereo";
import Trem from "../modal_ferroviario/Trem";
import ModalAquaticoForm from "../modal_aquatico/ModalAquatico";
import { TypeModal, TypeEmitente, TypeTransporte } from "../../../lists";

export default function FormManifesto() {

    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('principal');
    const formManifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const selectEstados = useSelector((state: RootState) => state.manifesto.selectEstados);
    const listaUfPercurso = useSelector((state: RootState) => state.manifesto.manifesto.infPercurso);
    const listaMunicipiosCarregamento = useSelector((state: RootState) => state.manifesto.manifesto.infMunCarrega);
    const listaMunicipiosDescarregamento = useSelector((state: RootState) => state.manifesto.manifesto.infMunDescarga);
    const estadoInicialRef = useRef<HTMLSelectElement>(null);
    const [showProdutoPredominante, setShowProdutoPredominante] = useState(false);
    const [showDocumentoManifesto, setShowDocumentoManifesto] = useState(false);
    const [showDocumentoConhecimento, setShowDocumentoConhecimento] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showMessageError, setShowMessageError] = useState('');

    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        dispatch(setManifesto({ [name]: value }));
        dispatch(clearError(name))

        if (name === 'tpemit') {
            if (value === '1') {
                setShowProdutoPredominante(true);
                setShowDocumentoConhecimento(true);
                dispatch(clearNFe());

            } else {
                setShowProdutoPredominante(false);
                setShowDocumentoConhecimento(false);
                dispatch(clearCTe());
            }
        }

        if (name === 'modal') {
            if (value === '3') {
                setShowDocumentoManifesto(true);
            } else {
                setShowDocumentoManifesto(false);
            }
        }
    }

    const handleChangeEstadoInicial = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;
        dispatch(setManifesto({ [name]: value }));

        if (value !== '') {
            auxService.getMunicipiosByUf(value).then(data => {
                dispatch(setSelectMunicipios(data));
            })
                .catch(error => console.error(error));
        } else {
            dispatch(setSelectMunicipios([
                {
                    id: 0,
                    name: 'Selecione uma UF Inicial',
                    estado: {
                        uf: ''
                    },
                    capital: 0,
                    cod_ibge: 0,
                }
            ]))
        }
    }

    const handleChangeEstadoFinal = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;
        if (value === "") {
            dispatch(setManifesto({ [name]: "" }));
            dispatch(setSelectMunicipiosCarregamento([]));
        } else {
            dispatch(setManifesto({ [name]: value }));
            auxService.getMunicipiosByUf(value).then(res => {
                dispatch(setSelectMunicipiosCarregamento(res));
            })
        }
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const listaErrors = [
            'prodPred',
            'modal_rodoviario',
            'modal_aereo',
            'modal_ferroviario',
            'modal_aquatico',
            'modal_ferroviario.trem'
        ];

        if (id === undefined) {
            try {
                await manifestoService.create(formManifesto).then(res => {
                    dispatch(clearManifesto());
                    navigate('/manifesto');
                })
            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 422) {
                        const newerrors = tratarErrors(error.response.data, listaErrors);
                        dispatch(gravarErrors({ ...newerrors }))
                        setShowMessageError('Houve erro ao gravar. Verifique o formulário.');
                        setShowError(true)
                    }
                }
            }

        } else {

            try {
                await manifestoService.update(id, formManifesto).then(res => {
                    dispatch(clearManifesto());
                    navigate('/manifesto');
                })
            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 422) {
                        const newerrors = tratarErrors(error.response.data, listaErrors);
                        dispatch(gravarErrors({ ...newerrors }))
                        setShowMessageError('Houve erro ao gravar. Verifique o formulário.');
                        setShowError(true)
                    }
                }
            }
        }
    }

    const handleCancelar = () => {
        navigate('/manifesto');
    }

    useEffect(() => {
        dispatch(clearManifesto());

        auxService.getEstados().then((estados) => {
            dispatch(setEstados(estados));
        }
        );

        if (!id) {
            if (formManifesto.ufini !== "") {
                auxService.getMunicipiosByUf(formManifesto.ufini).then(data => {
                    dispatch(setSelectMunicipios(data));
                }).catch(error => console.error(error));
            }

            if (formManifesto.uffim !== "") {
                auxService.getMunicipiosByUf(formManifesto.uffim).then(data => {
                    dispatch(setSelectMunicipiosCarregamento(data));
                }).catch(error => console.error(error));
            }

            auxService.getNextNumManifesto().then(res => {
                dispatch(setManifesto({ nmdf: res.numero }));
            }).catch(error => console.log(error));



        } else {
            manifestoService.get(id).then(data => {
                dispatch(loadManifesto(data));

                if (data.tpemit === 1) {
                    setShowProdutoPredominante(true);
                    setShowDocumentoConhecimento(true);
                }

                if (data.modal === 3) {
                    setShowDocumentoManifesto(true);
                } 


                auxService.getMunicipiosByUf(data.ufini).then(data => {
                    dispatch(setSelectMunicipios(data));
                }).catch(error => console.error(error));

                auxService.getMunicipiosByUf(data.uffim).then(data => {
                    dispatch(setSelectMunicipiosCarregamento(data));
                }).catch(error => console.error(error));

                dispatch(loadMunicipiosDescargaSelect())
            }).catch(error => console.error(error))
        }
    }, [])

    const disabledUFFinal = () => {
        return listaUfPercurso.length > 0 || listaMunicipiosDescarregamento.length > 0
    }
    const disabledUFInicial = () => {
        return listaMunicipiosCarregamento.length > 0
    }

    return (<>
        <Form onSubmit={handleSubmit} noValidate>
            <Card className="card-success card-outline">
                <Card.Header className="">
                    <div className="row d-flex justify-content-between">
                        <Col md>

                            <Button type="submit" className="me-2" >
                                <FontAwesomeIcon icon={faSave} /> Salvar
                            </Button>

                            <a href="javasctipt:void(0)"
                                onClick={handleCancelar} className="btn btn-danger">
                                <FontAwesomeIcon icon={faTimes} /> Cancelar
                            </a>
                        </Col>
                        <Col md="auto">
                            <JAlertaErrorFormulario
                                showError={showError}
                                close={setShowError}
                                messageError={showMessageError}
                                variant="danger" />
                        </Col>
                    </div>
                </Card.Header>

                <Card.Body className="p-2">
                    <Tabs defaultActiveKey="principal"
                        activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'principal')}
                        id="tab-example" className="mb-3"
                    >
                        <Tab eventKey="principal" title="Principal" className="px-1">
                            <Card className="card-primary card-outline mb-2">
                                <Card.Body>
                                    <Row className=" g-2">
                                        <Col md={'auto'}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>*Número</Form.Label>
                                                <Form.Control type="text" name="nmdf" value={formManifesto.nmdf}
                                                    className={`${errors.nmdf?.length > 0 ? "is-invalid" : ""}`}
                                                    onChange={handleChange} autoFocus />
                                                <MakeMessageError errors={errors} field="nmdf" />

                                            </Form.Group>
                                        </Col>

                                        <Col md>
                                            <Form.Group className="mb-2">
                                                <Form.Label>UF Inicial</Form.Label>
                                                <Form.Select name="ufini" value={formManifesto.ufini}
                                                    onChange={handleChangeEstadoInicial}
                                                    ref={estadoInicialRef} disabled={disabledUFInicial()}>
                                                    {selectEstados?.map((estado) => (
                                                        <option key={estado.id} value={estado.uf}>
                                                            {estado.uf === "" ? estado.name : estado.uf}
                                                        </option>
                                                    )
                                                    )}
                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="ufini" />
                                            </Form.Group>
                                        </Col>

                                        <Col md={'auto'}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Tipo Emitente</Form.Label>
                                                <Form.Select name="tpemit" value={formManifesto.tpemit}
                                                    onChange={handleChange} >
                                                    {TypeEmitente.map((x) => (
                                                        <option key={x.id} value={x.id}>{x.name}</option>
                                                    ))}
                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="tpemit" />
                                            </Form.Group>
                                        </Col>

                                        <Col md>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Tipo Transportador</Form.Label>
                                                <Form.Select name="tptransp" value={formManifesto.tptransp}
                                                    onChange={handleChange} >
                                                    {TypeTransporte.map((x) => (
                                                        <option key={x.id} value={x.id} >{x.name}</option>
                                                    ))}
                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="tptransp" />
                                            </Form.Group>
                                        </Col>

                                        <Col md>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Modal</Form.Label>
                                                <Form.Select name="modal" value={formManifesto.modal}
                                                    onChange={handleChange} >
                                                    {TypeModal.map((x) => (
                                                        <option key={x.id} value={x.id}>{x.name}</option>
                                                    ))}

                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="modal" />
                                            </Form.Group>
                                        </Col>

                                        <Col md>
                                            <Form.Group className="mb-2">
                                                <Form.Label>UF Final</Form.Label>
                                                <Form.Select name="uffim" value={formManifesto.uffim}
                                                    onChange={handleChangeEstadoFinal} disabled={disabledUFFinal()}>
                                                    {selectEstados?.map((estado) => {
                                                        return (
                                                            <option
                                                                key={estado.id}
                                                                value={estado.uf}>
                                                                {estado.uf === "" ? estado.name : estado.uf}
                                                            </option>
                                                        )
                                                    })}
                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="uffim" />
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                    {/* <FormTeste/> */}

                                </Card.Body>
                            </Card>
                            <Row className="mb-3 g-2">
                                <Col md>
                                    <MunicipioCarrega estadoInicialRef={estadoInicialRef} />
                                </Col>
                                <Col md>
                                    <UfPercurso />
                                </Col>
                            </Row>

                        </Tab>

                        {formManifesto.modal.toString() === '1' && (
                            <Tab eventKey="rodoviario" title="Rodoviário">
                                <Rodoviario />
                            </Tab>
                        )}

                        {formManifesto.modal.toString() === '2' && (
                            <Tab eventKey="aereo" title="Aéreo">
                                <ModalFormAereo />
                            </Tab>
                        )}

                        {formManifesto.modal.toString() === '3' && (
                            <Tab eventKey="aquatico" title="Aquaviáro">
                                <ModalAquaticoForm />
                            </Tab>
                        )}

                        {formManifesto.modal.toString() === '4' && (
                            <Tab eventKey="ferroviario" title="Ferroviário">
                                <Trem />
                            </Tab>
                        )}

                        <Tab eventKey="inf_documentos" title="Inf. Documentos">
                            <InfDocumentos
                                showDocumentoConhecimento={showDocumentoConhecimento}
                                showDocumentoManifesto={showDocumentoManifesto}
                            />
                        </Tab>

                        <Tab eventKey="inf_seguro" title="Inf. Seguros" className="px-2">
                            <Seguro />
                        </Tab>

                        <Tab eventKey="totalizadores" title="Totalizadores">
                            <Totalizador handleChange={handleChange} errors={errors} />
                        </Tab>

                        <Tab eventKey="inf_adicionais" title="Informações Adicionais">
                            <InfoManifesto handleChange={handleChange} />
                        </Tab>

                        <Tab eventKey="manifesto_lacre" title="Lacres do manifesto">
                            <LacresManifesto />
                        </Tab>

                        <Tab eventKey="autorizacao_download" title="Autorização Download">
                            <AutorizacaoDownload />
                        </Tab>

                        {showProdutoPredominante && (
                            <Tab eventKey="produto_predominante" title="Produto Predominante">
                                <ProdutoPredominante />
                            </Tab>
                        )}
                    </Tabs>

                </Card.Body>
                <Card.Footer style={{ backgroundColor: 'white' }}>
                    <CamposObrigatorios />
                </Card.Footer>
            </Card>
        </Form>

    </>)
}